export const generateNonce = (): string => {
  try {
    const randomBytes = new Uint8Array(16);
    crypto.getRandomValues(randomBytes);

    const base64Nonce = btoa(
      Array.from(randomBytes)
        .map((byte) => String.fromCharCode(byte))
        .join("")
    );

    return base64Nonce
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=/g, "");
  } catch (error) {
    console.error("Failed to generate nonce:", error);
    return Array.from({ length: 32 }, () =>
      Math.floor(Math.random() * 16).toString(16)
    ).join("");
  }
};

export const isValidNonce = (nonce: string): boolean => {
  if (!nonce) return false;
  if (nonce.length < 22 || nonce.length > 24) return false;
  return /^[A-Za-z0-9_-]+$/.test(nonce);
};

export const getCurrentNonce = (): string | null => {
  return (window as any).__nonce || null;
};

export default {
  generateNonce,
  isValidNonce,
  getCurrentNonce,
};
